import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import { ACTION_LIST } from "models/role/action";
import { SUBJECT_CIRCUIT_BREAKER } from "models/role/subject";
import { lazyRetry } from "utils/lazyRetry";

import { PAGE_URLS } from "../constants/PageUrls";

import type { ComponentType } from "react";

import type { Route } from "routes/RouteModel";

const RiskRulesProxy = lazyRetry(
  () => import("../pages"),
  "CircuitBreakerProxy",
  (module: { RiskRulesProxy: ComponentType<any> }) => ({
    default: module.RiskRulesProxy,
  })
);

export const riskRulesRoute: Route = {
  component: RiskRulesProxy,
  title: COMMON_TRANSLATION_KEYS.riskRules,
  path: PAGE_URLS.riskRules,
  can: {
    do: ACTION_LIST,
    on: SUBJECT_CIRCUIT_BREAKER,
  },
};
